/*
 * Lista numerada de un ranking del dashboard (más puntuales, los que llegan primero, más atrasos).
 * `describe(row)` devuelve {main, detail, tone}: el valor grande de la derecha y la insignia de abajo.
 * Las personas se muestran con EmployeeName (en la etapa 5 enlaza a la ficha del empleado).
 */
import React from "react";
import EmployeeName from "./EmployeeName";
import StatusBadge from "./StatusBadge";

const RankingList = ({title, hint, rows, describe, emptyText}) => (
    <div className="mc-panel">
        <h3 className="mc-panel__title">{title}</h3>
        {hint && <p className="mc-panel__hint">{hint}</p>}
        {rows.length === 0 ? (
            <p className="mc-inline-empty">{emptyText}</p>
        ) : (
            <ol className="mc-list mc-list--ranked">
                {rows.map((row) => {
                    const info = describe(row);
                    return (
                        <li key={row.id_empleado} className="mc-list__item">
                            <EmployeeName row={row}/>
                            <span className="mc-list__time mc-num">{info.main}</span>
                            <StatusBadge tone={info.tone} text={info.detail}/>
                        </li>
                    );
                })}
            </ol>
        )}
    </div>
);

export default RankingList;
